$(document).ready(function() {
  $("#slick-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: "#slick-nav",
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: true,
          autoplay: true
        }
      }
    ]
  });

  $("#slick-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    asNavFor: "#slick-for",
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $("#slick-for .slick-slide").click(function() {
    if ($(this).attr("data-url") !== "") {
      window.location.href = $(this).attr("data-url");
    }
  });

  function repairSliders(){
    var productGalleryFor = $("#product-gallery-for").children().length;
    console.log("Slides: " + productGalleryFor)
    if(productGalleryFor < 6){
      var slidesRemaining = 6 - (productGalleryFor + 1);
      var i = 0
      while(slidesRemaining >= i){
        console.log("Slides remaining: " + slidesRemaining)
        console.log($("#product-gallery-for").children().eq(i))
        $("#product-gallery-for").children().eq(i).clone().appendTo($("#product-gallery-for"));
        $("#product-gallery-nav").children().eq(i).clone().appendTo($("#product-gallery-nav"));
        i++;
      }
    }
    initProductSliders();
  }

  function initProductSliders(){
    $("#product-gallery-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: "#product-gallery-nav",
      autoplay: false
    });

    $("#product-gallery-nav").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: "#product-gallery-for",
      dots: false,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  };
  repairSliders()
  $("#hamburger").click(function() {
    $("#main-menu").slideToggle();
    $(this).toggleClass("c-header__hamburger--open");
  });

  $("body").on("click", "#open-branch-popup", function() {
    $("#branch-popup, .c-popup__overlay").fadeIn();
  });

  $("body").on("click", ".c-popup__overlay, .c-popup__close", function() {
    $(".c-popup, .c-popup__overlay").fadeOut();
  });

  $(".c-map__mobile-link").click(function() {
    
      $("html, body").animate(
        {
          scrollTop: $(".c-map__info").offset().top + 50
        },
        1000
      );
    
  });

  $(".c-map__pin").click(function(e) {
      if (window.matchMedia("(min-width: 768px)").matches) {
        $(".c-map__loader").fadeIn();
        $(".c-map").addClass("c-map--loading");
        setTimeout(function() {
          $("html, body").animate(
            {
              scrollTop: $(".c-map__info").offset().top + 50
            },
            1000
          );
          $(".c-map__loader").fadeOut();
          $(".c-map").removeClass("c-map--loading");
        }, 1000);
      } else {
        var newPin = $(this).find(".c-map__mobile-info");
        if (newPin.is(":visible")) {
          $(".c-map__mobile-info").fadeOut();
        } else {
          $(".c-map__mobile-info").fadeOut();
          $(this)
            .find(".c-map__mobile-info")
            .fadeIn();
        }
      }
  });
  
  $(".map-click-of-container").click(function() {
    $(".c-map__mobile-info").fadeOut();
  });
});
var productDetailTextHeight
$( document ).ready(function() {
  productDetailTextHeight = $('#productDetailText').height();
  $('#productDetailText').css('max-height', 450);
});
function toggleProductDetailText(){
    $('#productDetailText').toggleClass('c-product-detail__text--toggled')
    $('#productDetailReadMoreLine').toggleClass('c-product-detail__read-more-fade-line--toggled')
    if($('#productDetailText').height() > 450){
        $('#productDetailText').css('max-height', 450)
    }
    else{
        $('#productDetailText').css('max-height', productDetailTextHeight+50)
    }
}

$(window).scroll(function(){
  scrollTop = 50 - ($(window).scrollTop() / 18);
  $(".c-static-banner").css("background-position", "0%" + scrollTop + "%")
});
